export const defaultTextStyles = {
  text: "",
  textAlign: "center",
  textBaseline: "middle",
  offsetX: 0,
  offsetY: 0,
  font: {
    size: "12",
    name: "Circe-Regular",
  },
  fill: {
    color: "black",
  },
  stroke: {
    color: "black",
    width: 1,
  },
  background: {
    fill: {
      color: "",
    },
    stroke: {
      color: "",
      width: 1,
    },
  },
  padding: [0, 0, 0, 0],
};

export const defaultCircleStyles = {
  radius: 8,
  fill: {
    color: "gray",
  },
  stroke: {
    color: "black",
    width: 1,
  },
}